"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reporteDiarioConverter = void 0;
const reporteDiarioConverter = {
    toFirestore(reporte) {
        return reporte;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            version: data.version,
            id: data.id,
            estado: data.estado,
            fecha: data.fecha,
            idReceptor: data.idReceptor ?? 0,
            xml: data.xml,
            generacion: data.generacion,
            fechaReporte: data.fechaReporte,
            respuestaEnvio: data.respuestaEnvio,
            motivoRechazo: data.motivoRechazo,
            respuestaReporte: data.respuestaReporte,
            xmlRespuestaEnvio: data.xmlRespuestaEnvio ?? "",
            secuencia: data.secuencia
        };
    }
};
exports.reporteDiarioConverter = reporteDiarioConverter;
